export default __webpack_public_path__ + "static/media/IMG-20241005-WA0015.9751019f.jpg";